import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const { Title, Paragraph } = Typography;

const testimonialsData = [
  { id: 1, name: "Aisha Mwangi", role: "Data Science Student", text: "JectHub transformed my career with hands-on projects and expert mentorship. I landed my first job in just 3 months!", rating: 5 },
  { id: 2, name: "James Okoro", role: "Cybersecurity Enthusiast", text: "The ethical hacking course was a game-changer. Real-world challenges made learning exciting and practical.", rating: 4.5 },
  { id: 3, name: "Lilian Chebet", role: "AI Developer", text: "The AI products and community support here are unmatched. I built my portfolio and connected with top employers.", rating: 5 },
];

const TestimonialsSection = () => {
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating || 0);
    const halfStar = rating % 1 >= 0.5 ? 1 : 0;
    const stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} style={{ color: '#fadb14', marginRight: '3px' }} />);
    }
    if (halfStar) {
      stars.push(<FaStar key="half" style={{ color: '#fadb14', marginRight: '3px', opacity: 0.5 }} />);
    }
    return stars;
  };

  return (
    <Row gutter={16}>
      <Col span={24}>
        <section style={{ marginBottom: '40px', background: '#f0f2f5', padding: '40px 20px' }}>
          <Title level={2} style={{ fontSize: '18px', textAlign: 'center', color: '#1890ff' }}>
            What Our Learners Say
          </Title>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {testimonialsData.map((testimonial) => (
              <SwiperSlide key={testimonial.id}>
                <Card className="animated-card" style={{ borderRadius: '8px', textAlign: 'center', padding: '20px', height: '100%' }}>
                  <FaQuoteLeft style={{ fontSize: '24px', color: '#1890ff', marginBottom: '16px' }} />
                  <Paragraph style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>{testimonial.text}</Paragraph>
                  <div>{renderStars(testimonial.rating)}</div>
                  <Title level={5} style={{ marginTop: '16px', color: '#333' }}>{testimonial.name}</Title>
                  <Paragraph style={{ color: '#999', fontSize: '12px' }}>{testimonial.role}</Paragraph>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </Col>
    </Row>
  );
};

export default TestimonialsSection;